import { render, staticRenderFns } from "./PresetRegimenNew.vue?vue&type=template&id=c4c74e7c&scoped=true"
import script from "./PresetRegimenNew.vue?vue&type=script&lang=js"
export * from "./PresetRegimenNew.vue?vue&type=script&lang=js"
import style0 from "./PresetRegimenNew.vue?vue&type=style&index=0&id=c4c74e7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c74e7c",
  null
  
)

export default component.exports